type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[]
  push: Fbq
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

let initialized = false

export function initMetaPixel(pixelId: string) {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  if (!window.fbq) {
    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) fbq.callMethod(...args)
      else fbq.queue.push(args)
    } as Fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>) {
  window.fbq?.('track', event, params)
}

/** Fires InitiateCheckout whenever any link to the checkout URL is clicked. */
export function trackCheckoutClicks(checkoutUrl: string, pixelId: string, params: Record<string, unknown>) {
  const onClick = (e: MouseEvent) => {
    const link = (e.target as HTMLElement | null)?.closest('a')
    if (link && link.href.startsWith(checkoutUrl)) {
      // Make sure the pixel is loaded even if the visitor clicks before the delayed init.
      initMetaPixel(pixelId)
      trackPixelEvent('InitiateCheckout', params)
    }
  }
  document.addEventListener('click', onClick, true)
  return () => document.removeEventListener('click', onClick, true)
}
